import { app } from '../../../app';

app.factory('SmsUserRegistration', SmsUserRegistration);

/** @ngInject */
function SmsUserRegistration($resource) {
    return $resource('app/rest/smsUserRegistration', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-registration/sms-user-registration.service.js